<template>
  <font-awesome-icon
    class="dotcom-icon"
    :icon="[iconArt, iconName]"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import FontAwesomeIcon, { ART } from '../../config/icons'

export default {
  name: 'DotcomIcon',

  components: { FontAwesomeIcon },

  props: {
    name: {
      type: String,
      required: true,
    },

    art: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      iconName: '',
      iconArt: 'fal',
    }
  },

  created() {
    this.updateIcon()
  },

  methods: {
    updateIcon() {
      this.iconName = this.name

      const nameParts = this.name.split('-')
      if (ART[nameParts[0]]) {
        this.iconArt = nameParts.shift()
        this.iconName = nameParts.join('-')
      }

      if (this.art) {
        this.iconArt =
          Object.keys(ART).find((key) => ART[key] === this.art) ?? 'fal'
      }
    },
  },
}
</script>
